module.exports = __webpack_public_path__ + "static/media/tamper.0ba7b220.svg";